// Fachada de config de pipelines — métodos do repo (ver core.ts).
import { pipelinesConfigRepo } from './core';

// Re-exporta os tipos do domínio para consumo pela UI.
export type {
  FunnelRow,
  PipelineRow,
  StageRow,
  FunnelRef,
  PipelineWithFunnel,
  PipelineStageBrief,
  PipelineWithStages,
  CloserPipeline,
  CreatePipelineParams,
  InsertStageParams,
} from '@modules/pipelinesConfig';

export const listFunnelsFull                = pipelinesConfigRepo.listFunnelsFull;
export const listActivePipelines            = pipelinesConfigRepo.listActivePipelines;
export const listPipelinesInFunnel          = pipelinesConfigRepo.listPipelinesInFunnel;
export const listPipelinesForBoard          = pipelinesConfigRepo.listPipelinesForBoard;
export const listStagesInPipeline           = pipelinesConfigRepo.listStagesInPipeline;
export const listInactiveStageIds           = pipelinesConfigRepo.listInactiveStageIds;
export const getStageNames                  = pipelinesConfigRepo.getStageNames;
export const listPipelinesWithStages        = pipelinesConfigRepo.listPipelinesWithStages;
export const listCloserPipelinesInWorkspace = pipelinesConfigRepo.listCloserPipelinesInWorkspace;
export const updateFunnel                   = pipelinesConfigRepo.updateFunnel;
export const deactivateFunnel               = pipelinesConfigRepo.deactivateFunnel;
export const setPipelineFunnel              = pipelinesConfigRepo.setPipelineFunnel;
export const createPipeline                 = pipelinesConfigRepo.createPipeline;
export const updatePipeline                 = pipelinesConfigRepo.updatePipeline;
export const deactivatePipeline             = pipelinesConfigRepo.deactivatePipeline;
export const insertStage                    = pipelinesConfigRepo.insertStage;
export const updateStage                    = pipelinesConfigRepo.updateStage;
export const updateStageOrder               = pipelinesConfigRepo.updateStageOrder;
export const deactivateStage                = pipelinesConfigRepo.deactivateStage;
